import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';

import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import queryClient from './queries/query-client';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={configureStore()}>
            <App />
        </Provider>
    </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers://bit.ly/CRA-PWA
serviceWorker.unregister();
